import { useEffect, useRef } from "react";

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

const Turnstile = ({ action, onToken, resetRef }) => {
  const container = useRef(null);
  const widgetId = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    const render = () => {
      if (!container.current || !window.turnstile || widgetId.current != null) return;
      widgetId.current = window.turnstile.render(container.current, {
        sitekey: SITE_KEY,
        action,
        theme: "light",
        callback: (t) => onTokenRef.current(t),
        "expired-callback": () => onTokenRef.current(""),
        "error-callback": () => onTokenRef.current(""),
      });
      if (resetRef) {
        resetRef.current = () => {
          if (widgetId.current != null && window.turnstile) window.turnstile.reset(widgetId.current);
        };
      }
    };
    const timer = window.setInterval(() => {
      if (window.turnstile) {
        clearInterval(timer);
        render();
      }
    }, 100);
    return () => {
      clearInterval(timer);
      if (widgetId.current != null && window.turnstile) {
        window.turnstile.remove(widgetId.current);
        widgetId.current = null;
      }
    };
  }, [action, resetRef]);

  return <div ref={container} data-testid={`turnstile-${action}`} aria-label="Human verification" />;
};

export default Turnstile;
